<template>
	<div>
		<bsh-datatable
			:columns="columns"
            :buttons="buttons"
			:link="link"
            actionFild
            @selectRow="visualizar"
            @visualizar="visualizar"
			sorting>
		</bsh-datatable>
	</div>
</template>

<script>
export default {
    props: ['link'],
	data(){
		return {
            columns: [
                {
                    label: '#',
                    field: 'id',
                    sort: 'asc'
                },
                {
                    label: 'Data',
                    field: 'data',
                    sort: 'asc'
                }
            ],
            buttons: [
                {
                    action: 'visualizar',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-eye'
                },
            ]
    	}
	},
    methods: {
        visualizar(dado){
            this.$emit('show', dado.id);
        }
    }
}
</script>
